import { Component, OnInit } from "@angular/core";
import { CclRouteTab } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";

@Component({
    selector: "config-popup",
    templateUrl: "popup-section.view.html"
})
export class DefaultPopupView implements OnInit {
    navLinks: Array<CclRouteTab> = [new CclRouteTab("Basic", "default"), new CclRouteTab("Advanced", "advanced")];
    saveMessage = "popup-save-connection-message";
    constructor(public sharedService: SharedService) {}

    ngOnInit() {}

    saveFunction() {}

    getPopup() {
        return this.sharedService.currentPopup;
    }
} 